export { default } from './SpendRewards';
